export const BACKSPACE = 8;
export const TAB = 9;
export const ENTER = 13;
export const CAPSLOCK = 20;
export const ESC = 27;
export const SPACE = 32;
export const PAGE_UP = 33;
export const PAGE_DOWN = 34;
export const END = 35;
export const HOME = 36;
export const LEFT = 37;
export const UP = 38;
export const RIGHT = 39;
export const DOWN = 40;
export const INSERT = 45;
export const DELETE = 46;
export const ZERO = 48;
export const SEMICOLON = 52;
export const A = 65;
export const C = 67;
export const D = 68;
export const G = 71;
export const J = 74;
export const K = 75;
export const L = 76;
export const M = 77;
export const O = 79;
export const P = 80;
export const Q = 81;
export const R = 82;
export const S = 83;
export const T = 84;
export const U = 85;
export const V = 86;
export const X = 88;
export const Z = 90;
export const INSERT_MAC = 96;
export const ASTERISK = 106;
export const PLUS = 107;
export const MINUS = 109;
export const F1 = 112;
export const F2 = 113;
export const F3 = 114;
export const F4 = 115;
export const F5 = 116;
export const F6 = 117;
export const F7 = 118;
export const F8 = 119;
export const F9 = 120;
export const F10 = 121;
export const COLON = 186;
export const EQUAL = 187;
export const HYPHEN = 189;
export const DOT = 190;
export const SLASH = 191;
export const TRA = 192;
export const BACKSLASH = 220;
export const BRACKET_CLOSE = 221;
